import Toast from "react-native-toast-message"
import React, { useEffect, useState } from "react"

export const ShowToast = ({ type, message }) => {
    return Toast.show({
        type: type,
        visibilityTime: 5000,
        text1: message
    })
}
